import { getWeek } from 'date-fns';
import { WeightEntity } from '../types/weight';

export const weightsToAverageWeightPerWeek = (weights: WeightEntity[]) => {
  const weightsByWeeks = weights.reduce(
    (
      acc: {
        [key: string]: { weights: WeightEntity[]; year: number; week: number };
      },
      curr: WeightEntity
    ) => {
      const year = curr.date.getFullYear();
      const week = getWeek(curr.date, { weekStartsOn: 1 });
      const key = `${year}-${week}`;

      if (!acc[key]) acc[key] = { weights: [], year, week };

      (acc[key].weights = acc[key].weights || []).push(curr);

      return acc;
    },
    {}
  );

  return (
    Object.entries(weightsByWeeks)
      // key: year-week
      .map(([key, value]) => ({
        key,
        week: value.week,
        year: value.year,
        start: getMonday(value.weights[0].date),
        end: getSunday(value.weights[0].date),
        weight:
          value.weights.reduce((acc, w) => acc + w.weight, 0) /
          value.weights.length,
      }))
      // sort by year and week desc
      .sort((a, b) => {
        if (a.year === b.year) {
          return b.week - a.week;
        }
        return b.year - a.year;
      })
  );
};

const getMonday = (d: Date) => {
  const day = d.getDay(),
    diff = d.getDate() - day + (day === 0 ? -6 : 1);
  return new Date(d.setDate(diff));
};

const getSunday = (d: Date) => {
  const day = d.getDay(),
    diff = d.getDate() + (day === 0 ? 0 : 7 - day);
  return new Date(d.setDate(diff));
};
